import React from "react"
import classNames from "classnames"
import { getStyleTag } from "../../styles/dynamicStyles";

export default class ArticleStyleButton extends React.Component {
  render() {
    const classes = classNames("c-results-panel__display-option", this.props.extraClasses, {
      "state-active": this.props.active
    })

    const icon = "icon--view-" + this.props.style

    return (
      <button
        className={classes}
        role="menuitem"
        title={this.props.title}
        onClick={this.handleSwitchStyle}
      >
        {getStyleTag('c-results-panel__display-option')}
        <i className={"icon " + icon} aria-hidden />
      </button>
    )
  }

  handleSwitchStyle = () => {
    if (this.props.handleClick) {
      this.props.handleClick(this.props.style)
    }
  }
}



// WEBPACK FOOTER //
// ./webapp/components/elements/ArticleStyleButton.js